import { GET_RELATED_OPTIONS, GET_LIST_ACCOUNT_CMS_GROUP } from "./types";

export default {
  [GET_RELATED_OPTIONS]: (state) => state.related_options,
  [GET_LIST_ACCOUNT_CMS_GROUP]: (state) => state.account_cms_groups,
};
